import { createAction } from 'typesafe-actions';
import { ILog } from '../../@types/model/logs/Log';

export const dataSetLogs = createAction('SET_LOGS', resolve => (data : Array<ILog>) => resolve(data ? data : []));
